/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum WaitingListStatus {
  ACTIVE = 'active',
  PROCESSED = 'processed',
  CONVERTED = 'converted',
  CANCELED_BY_CUSTOMER = 'canceled_by_customer',
}
